import { useEffect } from 'react'
import {usePromotionStore} from './useStore'
import { flowResult } from 'mobx'


export const usePromotion = (productPromotionId?: string) => {
  const {fetchPromotionsByIds, promotions} = usePromotionStore()

  // Fetch promotion if its not already in the store
  useEffect(() => {
      (async function () {
        if (!productPromotionId) return
        await flowResult(fetchPromotionsByIds([productPromotionId], false))
      }())
  }, [productPromotionId])

  // Return from store
  return productPromotionId ? promotions[productPromotionId] : null
}
